import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, resolveImage } from "@/lib/api";
import { PageHeader, PrimaryBtn } from "@/components/site/shared";
import { openGhost } from "@/components/site/GhostAI";

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader overline="Our Services" title="Professional Exterior Cleaning"
        subtitle="Licensed, insured, and veteran-owned. Explore our confirmed services for residential and commercial properties across Orlando." />
      <section className="section-pad">
        <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => (
            <div key={s.id} className="group bg-white rounded-2xl overflow-hidden border border-gray-100 card-shadow btn-lift" data-testid={`service-${s.slug}`}>
              <div className="h-52 overflow-hidden">
                <img src={resolveImage(s.image)} alt={s.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <h3 className="font-head font-bold text-xl text-[var(--navy)] uppercase tracking-tight">{s.name}</h3>
                <p className="text-sm text-[var(--text-muted)] mt-2 leading-relaxed">{s.short_description}</p>
                <div className="flex flex-wrap gap-3 mt-4">
                  <Link to={`/services/${s.slug}`} className="text-sm font-semibold text-[var(--action)] hover:underline flex items-center gap-1">Learn More <ArrowRight className="w-4 h-4" /></Link>
                  <Link to={`/get-a-quote?service=${encodeURIComponent(s.name)}`} className="text-sm font-semibold text-[var(--red)] hover:underline">Request Quote</Link>
                  <button onClick={openGhost} className="text-sm font-semibold text-[var(--navy)] hover:underline">Ask Ghost AI</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
